import React, { Component } from "react";
import { connect, useDispatch } from "react-redux";

import axios, { CancelToken } from "axios";
import { Translate, I18n, setLocale } from "react-redux-i18n";

import TC from "./modals/TC";
import Privacy from "./modals/Privacy";
import Profile from "./Profile";

import { setAlert } from "../../../actions/alertActions";
import { logout, fetchUser } from "../../../actions/accountActions";

import { compressImage } from "../../utils/Utils";
import store from "../../../store";
import "../../../styles/components/account/manageAccount/ManageAccount.scss";
import contract from "../../../styles/images/contract.svg";
import manageUsers from "../../../styles/images/manageUsers.svg";
import padlock from "../../../styles/images/padlock.svg";
import checklist from "../../../styles/images/checklist.svg";
import signout from "../../../styles/images/signout.svg";
import camera from "../../../styles/images/camera.svg";
import avatar from "../../../styles/images/avatar.svg";
import lang from "../../../styles/images/lang.svg";
import Contracts from "./Contracts";
import AccessManagement from "./guestUser/AccessManagement";
import ManageUsers from "./ManageUsers";

import {
  fetchAllowedLanguagesOnly,
  formatLanguageCode,
  languageExists,
  fetchTranslationV2,
  loadMissingLanguage,
} from "../../../actions/languageActions";

import { CHANGE_ACCOUNT_LANGUAGE } from "../../../styles/utils/constants";

class ManageAccount extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      showPrivacy: false,
      showTC: false,
      content: "profile",
      picture: null,
      baseURL: null,
      dropdown: false,
    };

    this.handleSignOut = this.handleSignOut.bind(this);
    this.setContent = this.setContent.bind(this);
    this.handlePickPicture = this.handlePickPicture.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);
    this.renderLanguageButtons = this.renderLanguageButtons.bind(this);
  }

  changeLanguage = (lang) => {
    /* Updates the account language and changes the headers to the new language */
    let currentState = store.getState();
    let locale = currentState.i18n.locale;

    if (locale !== lang) {
      axios
        .patch(CHANGE_ACCOUNT_LANGUAGE + lang.language)
        .then((res) => {
          if (res.status === 200) {
            this.props.setLocale(lang.language);
            this.props.setAlert(
              I18n.t("accountManagement_languageUpdated"),
              "primary"
            );
            axios.defaults.headers.common["language"] = lang.language;
          }
        })
        .catch(
          (err) => console.log(err)
          //this.props.setAlert(I18n.t(err.response.data.message), "danger")
        );
    }
  };

  componentDidMount() {
    this._mounted = true;

    this.safeSetState({
      picture: this.props.accountData.avatar
        ? this.props.accountData.avatar + "?v=" + Date.now()
        : avatar,
    });

    this.safeSetState({
      baseURL: this.props.brand.baseURL,
    });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleSignOut(e) {
    this.props.logout(false, this.props.isAdmin);
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    let file = e.target.files && e.target.files[0];

    compressImage(file).then((picture) => {
      this.safeSetState({ picture }, () => {
        const patch = {
          imageContent: this.state.picture,
        };

        axios
          .patch("/api/private/users/image", patch, {
            cancelToken: new CancelToken((c) => (this.cancel = c)),
          })
          .then((res) => {
            if (res.status === 200) {
              this.props.fetchUser(
                this.props.accountData.internationalPrefix,
                this.props.accountData.phone
              );
              this.props.setAlert(I18n.t("Success"), "primary");
            }
          })
          .catch((err) =>
            this.props.setAlert(I18n.t(err.response.data.message), "danger")
          );
      });
    });
  }

  contentSwitch() {
    switch (this.state.content) {
      case "profile":
        return <Profile />;
      case "contracts":
        return <Contracts setContent={this.setContent} />;
      case "accessManagement":
        return <AccessManagement setContent={this.setContent} />;
      case "manageUsers":
        return <ManageUsers setContent={this.setContent} />;

      default:
        return <Profile />;
    }
  }

  setContent(content) {
    this.safeSetState({ content });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  renderLanguageButtons() {
    /* this Function will fetch the user available languages stored in redux (they were obtained from the first
    fetch languages request), then it will dynamically generate the buttons to change the language to each lang */

    const { availableLanguages, userLanguage, brandColors } = this.props;

    return availableLanguages.map((language, index) => {
      const selectedButton = language === userLanguage;
      return (
        <span
          key={index}
          className="languageButton"
          onClick={() => this.changeLanguage({ language })}
        >
          <span
            className="selectedLanguageButton"
            style={{
              ...(selectedButton && {
                backgroundColor: brandColors.secondaryColor,
              }),
            }}
          >
            <b>{formatLanguageCode(language)}</b>
          </span>
        </span>
      );
    });
  }

  render() {
    const windowConfig = [
      "toolbar=no",
      "location=no",
      "status=no",
      "menubar=no",
      "scrollbars=no",
      "resizable=yes",
      "width=800",
      "height=600",
    ];

    return (
      <div id="manageAccount" className="evio-container sidebar-fix">
        <div className="main">
          <div className="title">
            <Translate value="label_manageAccount" />
          </div>
          <div className="user">
            <input
              id="file-picker"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={this.handlePictureChange}
            />
            <button
              type="button"
              className="picture-picker"
              onClick={this.handlePickPicture}
            >
              <img
                src={this.state.picture}
                id="picture"
                className="avatar"
                alt="avatar"
              />
              <img src={camera} className="camera" alt="" />
            </button>
            <p className="name">{this.props.accountData.name}</p>
          </div>
          <div className="menu">
            <button
              type="button"
              className="clear"
              onClick={() => this.setContent("accessManagement")}
            >
              <img src={contract} className="icon" alt="" />
              <p>
                <Translate value="accessManagement_title" />
              </p>
            </button>
            {this.props.accountData.userPackage &&
              (this.props.accountData.userPackage.createB2BUsers ||
                this.props.accountData.userPackage.createB2CUsers) && (
                <button
                  type="button"
                  className="clear"
                  onClick={() => this.setContent("manageUsers")}
                >
                  <img src={manageUsers} className="icon" alt="" />
                  <p>
                    <Translate value="manageAccount_users" />
                  </p>
                </button>
              )}

            <button
              type="button"
              className="clear"
              onClick={() => {
                this.props.fetchAllowedLanguagesOnly();
                this.setState({ dropdown: !this.state.dropdown });
              }}
            >
              <img src={lang} className="icon" alt="" />
              <p>
                <Translate value="manageAccount_language" />
              </p>
            </button>
            {this.state.dropdown ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    alignContent: "center",
                  }}
                >
                  {this.renderLanguageButtons()}
                </div>
              </div>
            ) : (
              <div></div>
            )}

            <button
              type="button"
              className="clear"
              onClick={() => this.setContent("contracts")}
            >
              <img src={contract} className="icon" alt="" />
              <p>
                <Translate value="accountDetails_contracts" />
              </p>
            </button>
            <button
              type="button"
              className="clear"
              //onClick={() => this.safeSetState({ showPrivacy: true })}
              onClick={() =>
                window.open(
                    this.state.baseURL + "/" + this.props.locale + "/privacy",
                  "_blank",
                  windowConfig
                )
              }
            >
              <img src={padlock} className="icon" alt="" />
              <p>
                <Translate value="accountDetails_privacy" />
              </p>
            </button>
            <button
              type="button"
              className="clear"
              //onClick={() => this.safeSetState({ showTC: true })}
              onClick={() =>
                window.open(
                    this.state.baseURL +
                      "/" +
                      this.props.locale +
                      "/terms&conditions",
                  "_blank",
                  windowConfig
                )
              }
            >
              <img src={checklist} className="icon" alt="" />
              <p>
                <Translate value="accountDetails_termAndCond" />
              </p>
            </button>
            <button
              type="button"
              className="clear"
              onClick={this.handleSignOut}
            >
              <img src={signout} className="icon" alt="" />
              <p>
                <Translate value="accountDetails_signOut" />
              </p>
            </button>
          </div>
        </div>
        {this.contentSwitch()}

        <TC
          show={this.state.showTC}
          onHide={() => this.safeSetState({ showTC: false })}
        />

        <Privacy
          show={this.state.showPrivacy}
          onHide={() => this.safeSetState({ showPrivacy: false })}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  isAdmin: state.account.isAdmin,
  accountData: state.account.accountData,
  locale: state.i18n.locale,
  availableLanguages: state.language.languages,
  userLanguage: state.i18n.locale,
  brandColors: state.app.brand.colors,
});

export default connect(mapStateToProps, {
  logout,
  setAlert,
  fetchUser,
  setLocale,
  languageExists,
  fetchAllowedLanguagesOnly,
  fetchTranslationV2,
})(ManageAccount);
